/* eslint-disable react/prop-types */

import React, { useEffect, useContext, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import InputMask from "react-input-mask"
import { Grid, TextField, MenuItem, Divider, Typography } from "@material-ui/core"
import * as EmailValidator from 'email-validator';

import * as bookingsActions from "../../actions/bookingsActions"
import { i18n } from "../i18n"
import _ from "lodash"

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  root: {
    "& label.MuiFormLabel-root": {
      backgroundColor: "#fff",
      marginLeft: "-5px",
      padding: "0 6px",
    },
  },
}))

const PolicyDetails = (props) => {
  const { 
    localQuotation,
    handleQuotationChange,
    handleQuotationBlur,
    clickedComplete,
    getLabel,
    requireInsuranceDocument
  } = props
  
  return <>
    <Grid item xs={12}>
      <Divider variant="middle" style={{ margin: "10px 0" }} />
      <Typography variant="h6">Policy Details</Typography>
    </Grid>
    <Grid item xs={6}>
      <TextField
        required={requireInsuranceDocument}
        id="claimnumber"
        autoComplete="off-17"
        value={localQuotation.claimnumber}
        error={requireInsuranceDocument && _.isEmpty(localQuotation.claimnumber) && clickedComplete}
        onChange={handleQuotationChange}
        onBlur={handleQuotationBlur}
        inputProps={{ maxLength: 20 }}
        label={getLabel("customer.claimnumber", "Claim Number")}
        InputLabelProps={{
          shrink: true,
        }}
        margin="dense"
        variant="outlined"
        fullWidth
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        required={requireInsuranceDocument}
        id="policynumber"
        autoComplete="off-18"
        onChange={handleQuotationChange}
        onBlur={handleQuotationBlur}
        value={localQuotation.policynumber}
        error={requireInsuranceDocument && _.isEmpty(localQuotation.policynumber) && clickedComplete}
        inputProps={{ maxLength: 15 }}
        label={getLabel("customer.policynumber", "Policy Number")}
        InputLabelProps={{
          shrink: true,
        }}
        margin="dense"
        variant="outlined"
        fullWidth
      />
    </Grid>
  </>
}

const VoucherDocument = (props) => {
  const { 
    localQuotation,
    handleQuotationChange,
    handleQuotationBlur,
    clickedComplete,
    getLabel,
    isBeingEdited,
    requireVoucherDocument
  } = props

  if(isBeingEdited) {
    return <></>
  }

  return <>
    <Grid item xs={12}>
      <Divider variant="middle" style={{ margin: "10px 0" }} />
      <Typography variant="h6">Voucher Document</Typography>
    </Grid>
    <Grid item xs={12}>
      <TextField
        required={requireVoucherDocument}
        id="voucherNumber"
        autoComplete="off-17"
        value={localQuotation.voucherNumber}
        error={requireVoucherDocument && (/[^a-zA-Z0-9]/.test(localQuotation.voucherNumber) || _.isEmpty(localQuotation.voucherNumber)) && clickedComplete}
        onChange={handleQuotationChange}
        onBlur={handleQuotationBlur}
        inputProps={{ maxLength: 16 }}
        helperText={
          (requireVoucherDocument && /[^a-zA-Z0-9]/.test(localQuotation.voucherNumber) || _.isEmpty(localQuotation.voucherNumber)) && clickedComplete 
          ? "Required and must only have alphanumeric characters"
          : ""
        }
        label={getLabel("customer.voucherNumber", "Voucher Number")}
        InputLabelProps={{
          shrink: true,
        }}
        margin="dense"
        variant="outlined"
        fullWidth
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        required={requireVoucherDocument}
        id="billingInstructions1"
        autoComplete="off-18"
        onChange={handleQuotationChange}
        onBlur={handleQuotationBlur}
        value={localQuotation.billingInstructions1}
        error={requireVoucherDocument && (/[^a-zA-Z0-9]/.test(localQuotation.billingInstructions1) || _.isEmpty(localQuotation.billingInstructions1)) && clickedComplete}
        helperText={
          (requireVoucherDocument && /[^a-zA-Z0-9]/.test(localQuotation.billingInstructions1) || _.isEmpty(localQuotation.billingInstructions1)) && clickedComplete 
          ? "Required and must only have alphanumeric characters"
          : ""
        }
        inputProps={{ maxLength: 20}}
        label={getLabel("customer.billingInstructions1", "Billing Instructions 1")}
        InputLabelProps={{
          shrink: true,
        }}
        margin="dense"
        variant="outlined"
        fullWidth
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        id="billingInstructions2"
        autoComplete="off-18"
        onChange={handleQuotationChange}
        onBlur={handleQuotationBlur}
        value={localQuotation.billingInstructions2}
        error={/[^a-zA-Z0-9]/.test(localQuotation.billingInstructions2) && clickedComplete}
        helperText={
          /[^a-zA-Z0-9]/.test(localQuotation.billingInstructions2) && clickedComplete 
          ? "Must only have alphanumeric characters"
          : ""
        }
        inputProps={{ maxLength: 16}}
        label={getLabel("customer.billingInstructions2", "Billing Instructions 2")}
        InputLabelProps={{
          shrink: true,
        }}
        margin="dense"
        variant="outlined"
        fullWidth
      />
    </Grid>
  </>
}

const BookingDetails = (props) => {
  const classes = useStyles()
  const { clickedComplete, requireRenterAddress, requireRenterContactDetails, requireVoucherDocument, requireInsuranceDocument } = props
  const quotation = useSelector((state) => ({ ...state.quotation }))
  const bookings = useSelector((state) => ({ ...state.bookings }))
  const userInfo = useSelector((state) => ({ ...state.userInfo }))
  const { settings } = userInfo
  const serviceType = settings.meta.find(e => e.key === "serviceType").value
  const [localQuotation, setLocalQuotation] = useState({ ...quotation })
  const dispatch = useDispatch()

  useEffect(() => {
    if (quotation.cleared) {
      setLocalQuotation({ ...quotation })
    }
  }, [quotation.cleared])

  const labelContext = useContext(i18n)
  const getLabel = (label, defaultValue) => {
    if (i18n !== undefined) {
      return _.get(labelContext, `labels.${label}`, defaultValue)
    } else {
      return defaultValue
    }
  }

  const expiryLabel = getLabel("customer.expiry", "License Expiry")
  const phoneNoLabel = getLabel("customer.phone", "Phone Number")
  const mobileNoLabel = getLabel("customer.mobile", "Mobile Number")
  const postCodeLabel = getLabel("customer.postcode", "Post Code")
  const adPhoneLabel = getLabel("customer.adphone", "Phone Number")
  const adMobileLabel = getLabel("customer.admobile", "Mobile Number")

  const handleCustomerBlur = (e) => {
    dispatch(
      bookingsActions.setQuotation({
        customer: {
          ...quotation.customer,
          [e.target.name || e.target.id]: e.target.value,
        },
      })
    )
  }

  const handleCustomerChange = (e) => {
    setLocalQuotation({
      ...localQuotation,
      customer: {
        ...localQuotation.customer,
        [e.target.name || e.target.id]: e.target.value,
      },
    })
    const itinerary = {
      ...bookings.itinerary,
      customer: {
        ...localQuotation.customer,
        [e.target.name || e.target.id]: e.target.value,
      },
    }
    dispatch(bookingsActions.setBookings({itinerary}))
  }

  const handleQuotationBlur = (e) => {
    dispatch(
      bookingsActions.setQuotation({
        [e.target.name || e.target.id]: e.target.value,
      })
    )
  }

  const handleQuotationChange = (e) => {
    setLocalQuotation({
      ...localQuotation,
      [e.target.name || e.target.id]: e.target.value,
    })
  }

  return (
    <Grid container spacing={0} justify="center" className={classes.root}>
      <form autoComplete="off">
        <Grid container item xs={12} spacing={1} justify="space-between">
          <Grid item xs={6}>
            <TextField
              required
              id="firstname"
              autoComplete="off-1"
              value={localQuotation.customer.firstname}
              error={_.isEmpty(localQuotation.customer.firstname) && clickedComplete}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              label={getLabel("customer.firstname", "First Name")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              id="lastname"
              autoComplete="off-2"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.lastname}
              error={_.isEmpty(localQuotation.customer.lastname) && clickedComplete}
              label={getLabel("customer.lastname", "Last Name")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              variant="outlined"
              fullWidth
            />
          </Grid>
        </Grid>
        
        <Grid container item spacing={1} justify="center" xs={12}>
          <Grid item xs={12}>
            <TextField
              required={requireRenterAddress}
              id="address"
              autoComplete="off-6"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.address}
              error={requireRenterAddress && _.isEmpty(localQuotation.customer.address) && clickedComplete}
              label={getLabel("customer.address", "Address")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid container item spacing={1} justify="flex-end" xs={12}>
          <Grid item xs={6}>
            <TextField
              required={requireRenterAddress}
              id="city"
              autoComplete="off-7"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.city}
              error={requireRenterAddress && _.isEmpty(localQuotation.customer.city) && clickedComplete}
              label={getLabel("customer.city", "City")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required={requireRenterAddress}
              id="country"
              autoComplete="off-8"
              name="country"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              select
              value={localQuotation.customer.country}
              error={requireRenterAddress && _.isEmpty(localQuotation.customer.country) && clickedComplete}
              label={getLabel("customer.country", "Country")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem key={1} value="AU">
                Australia
              </MenuItem>
              <MenuItem key={2} value="NZ">
                New Zealand
              </MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={2}>
            <InputMask
              mask="9999"
              value={localQuotation.customer.postcode}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  required={requireRenterAddress}
                  id="postcode"
                  autoComplete="off-9"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  label={postCodeLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>

        </Grid>
        <Grid container item spacing={1} justify="center" xs={12}>
          <Grid item xs={6}>
            <TextField
              required={requireRenterContactDetails}
              id="email"
              autoComplete="off-3"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.email}
              error={requireRenterContactDetails && (!EmailValidator.validate(localQuotation.customer.email) || _.isEmpty(localQuotation.customer.email)) && clickedComplete}
              helperText={
                (requireRenterContactDetails && !_.isEmpty(localQuotation.customer.email) && !EmailValidator.validate(localQuotation.customer.email) && clickedComplete) 
                ? "Please enter a valid email address" : ""
              }
              label={getLabel("customer.email", "Email")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              type = "email"
            />
          </Grid>
          <Grid item xs={3}>
            <InputMask
              mask="\+\(69\) 999 9999 999999"
              value={localQuotation.customer.phone}
              error={requireRenterContactDetails && _.isEmpty(localQuotation.customer.phone) && clickedComplete}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  required={requireRenterContactDetails}
                  id="phone"
                  autoComplete="off-4"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  label={phoneNoLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={3}>
            <InputMask
              mask="\+\(69\) 999 9999 999999"
              value={localQuotation.customer.mobile}
              error={requireRenterContactDetails && _.isEmpty(localQuotation.customer.mobile) && clickedComplete}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  required={requireRenterContactDetails}
                  id="mobile"
                  autoComplete="off-5"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  label={mobileNoLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>
        </Grid>        
        <Grid container item spacing={1} justify="flex-end" xs={12}>
          {serviceType !== "Standard" ? <PolicyDetails 
            handleQuotationBlur={handleQuotationBlur}
            handleQuotationChange={handleQuotationChange}
            clickedComplete={clickedComplete}
            localQuotation={localQuotation}
            getLabel={getLabel}
            requireInsuranceDocument={requireInsuranceDocument}
          /> : <VoucherDocument 
            handleQuotationBlur={handleQuotationBlur}
            handleQuotationChange={handleQuotationChange}
            clickedComplete={clickedComplete}
            localQuotation={localQuotation}
            getLabel={getLabel}
            isBeingEdited={bookings.isBeingEdited}
            requireVoucherDocument={requireVoucherDocument}
          />}
          <Grid item xs={12}>
            <Divider variant="middle" style={{ margin: "10px 0" }} />
            <Typography variant="h6">Driver&apos;s License</Typography>
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="license"
              autoComplete="off-10"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.license}
              /* error={_.isEmpty(localQuotation.customer.license) && clickedNext} */
              label={getLabel("customer.license", "License Number")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="issuer"
              autoComplete="off-11"
              name="issuer"
              select
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.issuer}
              label={getLabel("customer.issuer", "License Issuer")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem key={1} value="AC">
                A.C.T
              </MenuItem>
              <MenuItem key={1} value="NS">
                New South Wales
              </MenuItem>
              <MenuItem key={1} value="NT">
                Northern Territory
              </MenuItem>
              <MenuItem key={1} value="QL">
                Queensland
              </MenuItem>
              <MenuItem key={1} value="SA">
                South Australia
              </MenuItem>
              <MenuItem key={1} value="TS">
                Tasmania
              </MenuItem>
              <MenuItem key={1} value="VI">
                Victoria
              </MenuItem>
              <MenuItem key={1} value="WA">
                Western Australia
              </MenuItem>
              <MenuItem key={2} value="NZ">
                New Zealand
              </MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <InputMask
              mask="9999-99-99"
              value={localQuotation.customer.expiry}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  id="expiry"
                  autoComplete="off-12"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  placeholder="YYYY-MM-DD"
                  label={expiryLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12}>
            <Divider variant="middle" style={{ margin: "10px 0" }} />
            <Typography variant="h6">Additional Driver</Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="adfirstname"
              autoComplete="off-13"
              type="search"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.adfirstname}
              label={getLabel("customer.addfirstname", "First Name")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="adlastname"
              autoComplete="off-14"
              type="search"
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              value={localQuotation.customer.adlastname}
              label={getLabel("customer.addlastname", "Last Name")}
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <InputMask
              mask="\+\(69\) 999 9999 999999"
              value={localQuotation.customer.adphone}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  id="adphone"
                  autoComplete="off-15"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  placeholder=""
                  label={adPhoneLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={6}>
            <InputMask
              mask="\+\(69\) 999 9999 999999"
              value={localQuotation.customer.admobile}
              onChange={handleCustomerChange}
              onBlur={handleCustomerBlur}
              maskChar=" "
            >
              {() => (
                <TextField
                  id="admobile"
                  autoComplete="off-16"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  label={adMobileLabel}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </InputMask>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}

export default BookingDetails
